import create from './createAction'

export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA'
export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT'
export const PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL'
export const SUBMIT_POST_PAYMENT = 'SUBMIT_POST_PAYMENT'
export const GET_BRAINTREE_PAYMENT_TOKEN = 'GET_BRAINTREE_PAYMENT_TOKEN'
export const SET_BRAINTREE_PAYMENT_TOKEN = 'SET_BRAINTREE_PAYMENT_TOKEN'
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'
export const REDEEM_AND_RESET_VOUCHERS = 'REDEEM_AND_RESET_VOUCHERS'
export const GET_ORDER_STATUS = 'GET_ORDER_STATUS'
export const SET_ORDER_STATUS = 'SET_ORDER_STATUS'

export const submitPostPayment = create(SUBMIT_POST_PAYMENT)
export const setPaymentData = create(SET_PAYMENT_DATA)
export const submitPayment = create(SUBMIT_PAYMENT)
export const paymentSuccessful = create(PAYMENT_SUCCESSFUL)
export const getBraintreePaymentToken = create(GET_BRAINTREE_PAYMENT_TOKEN)
export const setBraintreePaymentToken = create(SET_BRAINTREE_PAYMENT_TOKEN)
export const setPaymentMethod = create(SET_PAYMENT_METHOD)
export const redeemAndResetVouchers = create(REDEEM_AND_RESET_VOUCHERS)
export const getOrderStatus = create(GET_ORDER_STATUS)
export const setOrderStatus = create(SET_ORDER_STATUS)
